/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>推荐用户资料</el-breadcrumb-item>
      <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        
        
		<el-form label-width="120px" ref="editForm" :model="formProInfo" class="editForm">
		  <el-form-item label="广告名称" prop="productName">
		    <el-input size="small" v-model="formProInfo.name" auto-complete="off" placeholder="请输入分类名称"></el-input>
			<div class="tips">该名称不会在小程序上显示</div>
		  </el-form-item>
		  
		  <el-form-item label="状态" :prop="formProInfo.active">
		    <el-radio v-model="formProInfo.active" label="1">启用</el-radio>
		    <el-radio v-model="formProInfo.active" label="0">禁用</el-radio>
		  </el-form-item>
		  
		  <el-form-item label="序号" prop="sortNumber">
		    <el-input size="small" v-model="formProInfo.sortNumber" auto-complete="off" placeholder="请输入序号,数字越小越靠前，整数"></el-input>
		  </el-form-item>
		  
		  <el-form-item   label="广告图片">
		    
		    <el-upload
		      class="upload-demo"
		      :action="uploadUrl()"
		      :http-request="customUpload1"
		      :on-preview="handlePreview1"
		      :on-remove="handleRemove1"
		      :file-list="resultFilelist1"
		      :limit='1'
		      accept=".png,.jpg,.jpeg"
		      list-type="picture-card">
			  <div slot="file" slot-scope="{file}">
			  		<el-progress type="circle" :percentage="progressPercent" v-if="isUpload"></el-progress>
			       <img
			         class="el-upload-list__item-thumbnail"
			         :src="file.url" alt=""
			       >
			       <span class="el-upload-list__item-actions">
			         <!-- <span
			           class="el-upload-list__item-preview"
			           @click="handlePictureCardPreview(file)"
			         >
			           <i class="el-icon-zoom-in"></i>
			         </span> -->
			        
			         <span
			           class="el-upload-list__item-delete"
			           @click="handleRemove1(file)"
			         >
			           <i class="el-icon-delete"></i>
			         </span>
			       </span>
			   </div>
		      <el-button size="small" type="primary">点击上传图片</el-button>
		      <div slot="tip" class="el-upload__tip">仅支持上传一张图片（建议上传375x140 px的图片）</div>
		    </el-upload>
		    
		  </el-form-item>
		  
		  <el-form-item label="">
		   <el-select size="small" v-model="formProInfo.recommendId" placeholder="请选择产品推荐">
		       <el-option v-for="(item,index) in typeList1" :label="item.name" :value="item.id"></el-option>
		    </el-select>
		  </el-form-item>
		  
		</el-form>
		
		
		<div slot="footer" class="dialog-footer">
		  <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">保存</el-button>
		</div>
		
		
		
		
		
		
      </div>
    </template>

    <script>
    // 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      getRecommendTypeList,
	  createRecommendAdvert,
	  updateRecommendAdvert,
	  getRecommendAdvertById
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
		  isUpload: false,//文件是否上传中
		  progressPercent: 0,//进度条当前进度
          loading: false, //是显示加载
		  keytype:0,
          title: '导购分类新增',
		  typeList1:'',
          // 请求数据参数
          formProInfo: {
            // 分类名称(支持右模糊查询)
            name: '',
            //所属导购：1-导购知识视频；2-服务视频；3-导购文件
            category:'1',
            //分类状态：0-禁用；1-启用
            active:'1',
			recommendId:'',
			sortNumber:''
          },
		  diaFrom:{
		    desc:'',
		    list:[]
		  },
    	  id:'',
		  shuo:'',
		 resultFilelist1:[]
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)
		

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.shuo = this.$route.query.shuo
		  this.formProInfo.category = String(this.$route.query.category)
		  this.changetype()
		  if(this.shuo=='新增' && this.formProInfo.category=='1'){
		  		this.title = '产品广告位新增'
		  }else if(this.shuo=='编辑' && this.formProInfo.category=='1'){
		  		this.title = '产品广告位编辑'
		  		this.handleEdit()
		  }else if(this.shuo=='新增' && this.formProInfo.category=='2'){
		  		this.title = '活动广告位新增'
		  }else{
		  		this.title = '活动广告位编辑'
		  		this.handleEdit()
		  }
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getRecommendAdvertById(this.id).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         let data = res.data
		         this.formProInfo.name = data.name
		         this.formProInfo.active= String(data.active)
		         this.formProInfo.recommendId= String(data.recommendId)
		         this.formProInfo.sortNumber = data.sortNumber
				 
				 this.resultFilelist1 = []
				 
				 this.resultFilelist1.push({
				   url:data.pictureInfo.fileTemporaryUrl,
				   fileTemporaryUrl:data.pictureInfo.fileTemporaryUrl,
				   fileId:data.pictureInfo.fileId,
				   name: data.pictureInfo.ossFile.fileName,
				 })
				 
				
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		  uploadUrl(){
		    return '/mtl/marking/api/main/oss-file/upload-file'
		  },
		  handlePreview1(file){
		    console.log(file)
		   
		  },
		 
		  customUpload1(req){
		    let _this = this
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
		    this.isUpload = true
		    this.progressPercent = 45
		      uploadFile(this.uploadUrl(), formData).then(response => {
		  				 
		        if(response.data.success){
					this.progressPercent = 100
					setTimeout(()=>{
						this.isUpload = false
					},1500)
		          let data = response.data.data
		          console.log(data)
		          _this.resultFilelist1.push({
		                  url:data.fileTemporaryUrl,
		                  fileTemporaryUrl:data.fileTemporaryUrl,
		                  fileId:data.fileId,
		                  name: data.ossFile.fileName,
		                  uid: req.file.uid,
		                  mediaObjInfo:data
		              })
		            
		          
		          
		        }else{
		          this.$message.error('文件上传失败，请稍后再试！')
		        }
		       console.log(999999998888,_this.resultFilelist1)
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		        console.log(error)
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		 
		  handleRemove1(file,fileList){
		    let _this = this
		    console.log(file)
		    if(!file){
		      return
		    }
		    const index2 = this.resultFilelist1.findIndex(item => item.fileId === file.fileId)
		     console.log(index2)
		     this.resultFilelist1.splice(index2,1);
		  },
		//编辑
		goback() {
			this.$router.push({ path: '/advertisement?category='+this.formProInfo.category})
		 
		},
		
	  changetype(e){
		  let prm = {
			  category:this.formProInfo.category
		  }
		  getRecommendTypeList(prm).then(res => {
			console.log(123)
			this.loading = false
			if (res.success == false) {
			  this.$message({
				type: 'info',
				message: res.msg
			  })
			} else {
				this.typeList1 = res.data	
			
			}
		  })
	  },
	  
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


        
        
        // 编辑、添加提交方法
        saveProInfo(){
			let _this = this
             if(!_this.formProInfo.name){
              return _this.$message({
                      type: 'warning',
                      message: '请填写分类名称'
                    })
            }
			if(!_this.formProInfo.recommendId){
			  return _this.$message({
			          type: 'warning',
			          message: '请填选择推荐名称'
			        })
			}
			console.log(1234444,_this.resultFilelist1)
			if(_this.resultFilelist1.length==0){
				return _this.$message({
				        type: 'warning',
				        message: '请上传文件！'
				      })
			}
			_this.formProInfo.sortNumber = Number(_this.formProInfo.sortNumber)
			let sortNumbertype = Number.isInteger(_this.formProInfo.sortNumber)
			if(sortNumbertype==false){
			  return _this.$message({
			          type: 'warning',
			          message: '请填写整数！'
			        })
			}
			
			_this.formProInfo.pictureInfo = _this.resultFilelist1[0]
			if(_this.formProInfo.sortNumber==''){
				_this.formProInfo.sortNumber=null
			}
			console.log(1234449999,_this.formProInfo.sortNumber)
            if(_this.shuo=='新增'){
				createRecommendAdvert(_this.formProInfo).then(res => {
				  console.log(123)
				  _this.loading = false
				  if (res.success == false) {
				    _this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   _this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				  }
				})
			}else{
				_this.formProInfo.id = _this.id
				// let parm = {
				// 	name:this.formProInfo.name,
				// 	category:this.formProInfo.category,
				// 	active:this.formProInfo.active,
				// 	id:this.formProInfo.id,
				// }
				updateRecommendAdvert(_this.formProInfo).then(res => {
				  console.log(123)
				  _this.loading = false
				  if (res.success == false) {
				    _this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   _this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				  }
				})
			}
          
    		
        },

       

        // 选择复选框事件
        selectChange(val) {
          this.selectdata = val
        },
       
        

      }
    }
    </script>

    <style scoped>
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
  .tips{
	  color: #8c939d;
  }
    </style>





// WEBPACK FOOTER //
// src/views/userprofile/advertisementadd.vue